<app-competency-modal
  [allCompetencies]="allCompetencies"
  [assignedCompetencies]="assignedCompetencies"
  [competencyGroups]="competencyGroups"
  [selectableCompetencyGroups]="selectableCompetencyGroups"
  [filterAction]="filterAction"
  [saveAction]="saveAction"
  [isLevelShown] = false
></app-competency-modal>
